import { render, staticRenderFns } from "./ViewInteractiveTemplate.vue?vue&type=template&id=f6bc6806&scoped=true"
import script from "./ViewInteractiveTemplate.vue?vue&type=script&lang=js"
export * from "./ViewInteractiveTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewInteractiveTemplate.vue?vue&type=style&index=0&id=f6bc6806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bc6806",
  null
  
)

export default component.exports